import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import cutPlayerCard from './assets/cutPlayerCard.webp';
import footballCutPlayerCard from './assets/footballCutPlayerCard.webp';

/*
 * display rounded cash prize values no matter the currency
 */
export const ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY = 2000;

export const getCutPlayerCard = (sport: Sport) => {
  switch (sport) {
    case Sport.NBA:
      return cutPlayerCard;
    case Sport.BASEBALL:
      return cutPlayerCard;
    case Sport.FOOTBALL:
    default:
      return footballCutPlayerCard;
  }
};

export const scoreAverageCountBySport: Record<Sport, string> = {
  [Sport.NBA]: '10',
  [Sport.FOOTBALL]: '10',
  [Sport.BASEBALL]: '10',
};
